const Utils = {};

Utils.converter = new showdown.Converter();

Utils.createSubscription = (channel, onData, params= {}) => {
  return Shared.consumer.subscriptions.create(
      {channel: channel, ...params},
      {
        connected() {},
        disconnected() {},
        received(data) {
          onData(data);
        }
      }
  );
};

export default Utils;
